export default __webpack_public_path__ + "static/media/photohow.6e13e50e.png";